var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.playerReady)?_c(_vm.viewComponent,{key:_vm.viewComponentKey,tag:"component"}):_vm._e(),(!_vm.playerReady)?_c(_vm.errorComponent,{tag:"component",attrs:{"msg":_vm.errorMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }